import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { trackOpenDealSidebar } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const NameCellHoverContent = ({
  onClick
}) => {
  const isDealStageView = useSelector(getIsDealStageView);
  return /*#__PURE__*/_jsx(UIButton, {
    responsive: false,
    size: "extra-small",
    use: "tertiary-light",
    onClick: () => {
      trackOpenDealSidebar(isDealStageView);
      onClick();
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "repOverviewTable.viewDeals"
    })
  });
};
export default NameCellHoverContent;